(() => {
  const perSecond = 440e9 / (365.25 * 24 * 60 * 60)
  const key = "shrimple:arrived"
  let arrived = Number(sessionStorage.getItem(key))
  if (!arrived) {
    arrived = Date.now()
    sessionStorage.setItem(key, String(arrived))
  }
  const format = new Intl.NumberFormat("en-US")
  const counters = document.querySelectorAll("[data-shrimp-count]")
  const tick = () => {
    const value = format.format(Math.floor(((Date.now() - arrived) / 1000) * perSecond))
    counters.forEach((node) => { node.textContent = value })
  }
  if (counters.length) {
    tick()
    setInterval(tick, 80)
  }

  const menu = document.getElementById("site-menu")
  const openButton = document.querySelector("[data-menu-open]")
  const closeButton = document.querySelector("[data-menu-close]")
  if (menu && openButton && closeButton) {
    const setOpen = (open) => {
      menu.hidden = !open
      openButton.setAttribute("aria-expanded", String(open))
      document.body.style.overflow = open ? "hidden" : ""
      if (open) closeButton.focus()
      else openButton.focus()
    }
    openButton.addEventListener("click", () => setOpen(true))
    closeButton.addEventListener("click", () => setOpen(false))
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !menu.hidden) setOpen(false)
    })
  }
})()
